import script from "./TextNotice.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextNotice.vue?vue&type=script&setup=true&lang=ts"

import "./TextNotice.vue?vue&type=style&index=0&id=951dcc18&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-951dcc18"]])

export default __exports__